import { render, staticRenderFns } from "./ListImageSwipeArticle.vue?vue&type=template&id=055c028c"
import script from "./ListImageSwipeArticle.ts?vue&type=script&lang=ts&external"
export * from "./ListImageSwipeArticle.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports